import React, { useContext } from "react";
import "../../../../../ui-styles/sliders/RightFullSlider.css";
import "../../../../../ui-styles/profile/SlideProfileDetails.css";
import { LangCtx } from "../../../../../lib/context";
import { addrLangObj } from "../../../../../locale/address/index";

const ClinicProfileSlide = (props) => {
    const { l } = useContext(LangCtx);
    const al = addrLangObj[l.locale];
    const { data } = props;

    return (
        <div className={props.open ? "rightFullSlider rightSliderIn" : "rightFullSlider"}>
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>{l.profile}</span>
                    </div>
                    <div className="hdrActionGroup">
                        <div className="hdrActItem close" onClick={props.closeSlide}></div>
                    </div>
                </div>
            </div>
            <div className="rightSliderBdy">
                <div className="profileContainer">
                    <div className="profileTop">
                        <div className="profileAvtr">
                            {data && data.profileImage && data.profileImage.url !== '' ?
                                <img src={data.profileImage.url} alt="avatar" />
                                :
                                <div className="roundimg">{data.firstName ? data.firstName.charAt(0) : 'C'}</div>
                            }
                        </div>
                        <h2 className="profileTxtL">{data.clinicName && data.clinicName !== '' ? data.clinicName : '--'}</h2>
                        <span className="profileTxtS">{data.consultId && data.consultId !== '' ? data.consultId : '--'}</span>
                    </div>

                    <div className="profileDetails">
                        <div className="profileDtlHdr">
                            <span className="profileDtlTxt">{l.details}</span>
                        </div>
                        <div className="profileDtlGroup">
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.clc_contact_name}<small>{data.contactName ? data.contactName : ''}</small></span>
                            </div>
                            {/* <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.doc_prev}<small>{data.doctorPrivligies && data.doctorPrivligies.advice ? 'Advice' : ''}{data.doctorPrivligies && data.doctorPrivligies.uploadPrescription ? ', Upload Prescription' : ''}{data.doctorPrivligies && data.doctorPrivligies.prescription ? ', Prescription.' : ''}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.pat_prev}<small>{data.patientPriviligies && data.patientPriviligies.screenShare ? 'Screenshare' : ''}</small></span>
                            </div> */}
                            {data.doctorPrivligies && <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.doc_prev}:<small>
                                    {data.doctorPrivligies && (data.doctorPrivligies.advice && !data.doctorPrivligies.uploadPrescription && !data.doctorPrivligies.prescription) ? 'Advice' : ''}
                                    {data.doctorPrivligies && (!data.doctorPrivligies.advice && data.doctorPrivligies.uploadPrescription && !data.doctorPrivligies.prescription) ? 'Upload Prescription' : ''}
                                    {data.doctorPrivligies && (!data.doctorPrivligies.advice && !data.doctorPrivligies.uploadPrescription && data.doctorPrivligies.prescription) ? 'Prescription' : ''}
                                    {data.doctorPrivligies && (data.doctorPrivligies.advice && data.doctorPrivligies.uploadPrescription && !data.doctorPrivligies.prescription) ? 'Advice, Upload Prescription' : ''}
                                    {data.doctorPrivligies && (!data.doctorPrivligies.advice && data.doctorPrivligies.uploadPrescription && data.doctorPrivligies.prescription) ? 'Upload Prescription, Prescription' : ''}
                                    {data.doctorPrivligies && (data.doctorPrivligies.advice && !data.doctorPrivligies.uploadPrescription && data.doctorPrivligies.prescription) ? 'Advice, Prescription' : ''}
                                    {data.doctorPrivligies && (data.doctorPrivligies.advice && data.doctorPrivligies.uploadPrescription && data.doctorPrivligies.prescription) ? 'Advice, Upload Prescription, Prescription' : ''}</small></span>
                            </div>}
                            {data.patientPriviligies && <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.pat_prev}:<small>{data.patientPriviligies && data.patientPriviligies.screenShare ? 'Screenshare' : ''}</small></span>
                            </div>}
                        </div>

                        <div className="profileDtlHdr">
                            <span className="profileDtlTxt">{l.contact_details}</span>
                        </div>
                        <div className="profileDtlGroup">
                            {/* <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.civil_number}:<small>{data.civilNumber ? data.civilNumber : ''}</small></span>
                            </div> */}
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_email}<small>{data.email && data.email !== '' ? data.email : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_phone_no}<small>{data.countryCode ? `+${data.countryCode} ` : ''}{data.phone ? data.phone : '--'}</small></span>
                            </div>

                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_address}<small>{data.address && data.address !== '' ? data.address : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_city}<small>{data.city && data.city !== '' ? al[data.city] : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_state}<small>{data.stateName && data.stateName !== '' ? al[data.stateName] : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_country}<small>{data.country && data.country !== '' ? al[data.country] : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_pin}<small>{data.pincode && data.pincode !== '' ? data.pincode : '--'}</small></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClinicProfileSlide;